import keyBy from 'lodash/keyBy';

export const gateways = [
  { id: 'paypaltransaction', name: 'Paypal' },
  { id: '780', name: '*780#' },
  { id: 'paypingtransaction', name: 'PayPing' },
];

export const gatewayMap = keyBy(gateways, 'id');
